<template>
  <div>
  <v-card v-if="!partialRule">
    <v-switch :disabled="isLocked" v-model="rule.use" @change="updateRule">
      <template v-slot:label>
        <div><strong :class="rule.use ? 'success--text' : 'disabled--text'">{{label}}</strong></div>
      </template>
    </v-switch>
    <v-btn
      :disabled="isLocked"
      icon
      v-if="groupRule"
      @click="removeGroupRule"
      style="position:absolute;top:0px;right:10px"
    >
      <v-icon>mdi-trash-can-outline</v-icon>
    </v-btn>

    <v-row v-if="rule.use && (sliderRule || groupRule)">
      <v-col class="px-4">
        <v-range-slider
          @change="updateRule"
          v-model="slider.range"
          :max="slider.max"
          :min="slider.min"
          hide-details
          class="align-center"
          thumb-label="always"
          :thumb-size="24"
          :readonly="isLocked"
        ></v-range-slider>
      </v-col>
    </v-row>

    <div v-if="rule.use && fieldsRule">
      <v-col class="d-flex" cols="12" sm="12">
        <v-text-field
          label="Från"
          dense
          outlined
          v-model="slider.range[0]"
          hide-details="false"
          @change="updateRule"
          :readonly="isLocked"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="12">
        <v-text-field
          label="Till"
          dense
          outlined
          v-model="slider.range[1]"
          hide-details="false"
          @change="updateRule"
          :readonly="isLocked"
        ></v-text-field>
      </v-col>
    </div>

    <slot v-if="rule.use"></slot>
  </v-card>
  <v-row v-if="rule.use && partialRule">
    <v-col class="px-4">
      <v-range-slider
        @change="updateRule"
        ticks="always"
        :tick-labels="racesArray"
        tick-size="4"
        v-model="slider.range"
        :max="slider.max"
        :min="slider.min"
        hide-details
        class="align-center"
        :thumb-label='trueState'
        track-color="grey"
        :thumb-size="24"
        :label="label"
        :readonly="isLocked"
      ></v-range-slider>
    </v-col>
  </v-row>
</div>
</template>
<style>
</style>
<script>
import { mapActions } from 'vuex'

export default {

  props: ['rule', 'system', 'type', 'min', 'max', 'label'],
  data () {
    return {
      slider: {
        min: this.min || 0,
        max: this.max || 0,
        range: [this.rule.min || 0, this.rule.max || 0]
      },
      fieldsRule: this.type === 'fields',
      sliderRule: this.type === 'slider',
      partialRule: this.type === 'partial',
      compositeRule: this.type === 'composite',
      groupRule: this.type === 'group',
      racesArray: [...Array(10).keys()].map(String),
      trueState: true
    }
  },

  methods: {
    ...mapActions(['setRuleValuesAction', 'removeGroupRuleAction']),

    updateRule () {
      const ruleObj = { rule: this.rule.rule, id: this.system.id, use: this.rule.use }
      if (this.sliderRule || this.fieldsRule || this.partialRule || this.groupRule) {
        ruleObj.min = this.slider.range[0] || 0
        ruleObj.max = this.slider.range[1] || 0
      }

      if (!this.slider.range[0]) { this.slider.range[0] = 0; this.$forceUpdate() }
      if (!this.slider.range[1]) { this.slider.range[1] = 0; this.$forceUpdate() }
      if (this.rule.prio) { ruleObj.prio = this.rule.prio }
      if (this.rule.group) { ruleObj.group = this.rule.group }
      this.setRuleValuesAction(ruleObj)
    },

    removeGroupRule () {
      const ruleObj = Object.assign({}, this.rule)
      ruleObj.id = this.system.id
      this.removeGroupRuleAction(ruleObj)
    }
  },

  computed: {
    isLocked () {
      return this.system.locked
    }
  }
}
</script>
